import { createIcon } from '../createIcon';

export const ShapesIconConfig = {
  name: 'ShapesIcon',
  height: 512,
  width: 512,
  svgPath: 'M512 320v160c0 17.67-14.33 32-32 32H320c-17.67 0-32-14.33-32-32V320c0-17.67 14.33-32 32-32h160c17.67 0 32 14.33 32 32zm-384-64C57.31 256 0 313.31 0 384s57.31 128 128 128 128-57.31 128-128-57.31-128-128-128zm351.03-32c25.34 0 41.18-26.67 28.51-48L412.51 16c-12.67-21.33-44.35-21.33-57.02 0l-95.03 160c-12.67 21.33 3.17 48 28.51 48h190.06z',
  yOffset: 0,
  xOffset: 0,
  transform: ''
};

export const ShapesIcon = createIcon(ShapesIconConfig);

export default ShapesIcon;